import LoadingIndicator from 'app/components/LoadingIndicator';
import LoadingText from 'app/components/LoadingText';
import PayverseDirectHeader from 'app/components/PayverseDirectHeader';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const EcontextMobProcess = () => {
  const { t } = useTranslation();
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');
  const paramTid = new URLSearchParams(searchParams).get('tid');
  const approvalNo = new URLSearchParams(searchParams).get('approvalNo');
  const [isIframe, setIsIframe] = useState(false);

  useEffect(() => {
    if (paramPayUrl) {
      setIsIframe(true);
    }
  }, []);

  return (
    <>
      <div className="payverse-wrap">
        <div className="payverse">
          {paramPayUrl && isIframe ? (
            <>
              <iframe
                id="payment-iframe"
                src={paramPayUrl}
                width="100%"
                height="90%"
              ></iframe>
              <div
                className="c-section"
                style={{ height: '5%', display: 'flex', alignItems: 'center' }}
              >
                <div
                  className="box"
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    marginLeft: '0',
                    alignItems: 'center',
                  }}
                >
                  <button
                    className="orange"
                    onClick={() => {
                      if (paramTid) {
                        setIsIframe(false);
                        navigate(
                          `/mobile/econtext/result?tid=${paramTid}&approvalNo=${approvalNo}&payUrl=${paramPayUrl}`,
                        );
                      }
                    }}
                  >
                    {t('payment_confirm')}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="payverse-wrap">
              <div className="payverse">
                <PayverseDirectHeader />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    height: '70%',
                  }}
                >
                  <LoadingIndicator />
                  <LoadingText />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EcontextMobProcess;
